// extracted by mini-css-extract-plugin
export default {"profileTabs":"updateProfile_profileTabs__iMDXZ","custTabs":"updateProfile_custTabs__lILmq","custTabContent":"updateProfile_custTabContent__SHCwA"};